/* =========================================================
   Título de la pestaña del navegador
   ---------------------------------------------------------
   Fuente única: `meta.title` de la ruta (ver router/index.js).
   Este helper se usa para los títulos dinámicos, los que sólo se
   conocen después de cargar datos: nombre de la genética, título
   de la nota del blog, estado del registro, etc.
   ========================================================= */

export const BRAND = "Heaven's Fruit";

/**
 * Setea el título del documento agregando la marca si falta.
 * @param {string} [title] Título de la sección (sin la marca).
 */
export function setPageTitle(title) {
  if (typeof document === "undefined") return;

  const clean = typeof title === "string" ? title.trim() : "";
  document.title = !clean || clean.includes(BRAND) ? clean || BRAND : `${clean} - ${BRAND}`;
}
